var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4928 15H2.50719C1.12731 15 0 13.8727 0 12.4928V2.50719C0 1.12731 1.12731 0 2.50719 0H12.4928C13.8727 0 15 1.12731 15 2.50719V12.4928C15 13.8789 13.8788 15 12.4928 15Z",
    fill: "#EE2D2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50296 11.3532C6.47422 11.3532 5.50707 10.9528 4.78017 10.2259C4.05327 9.49901 3.65286 8.53186 3.65286 7.50312C3.65286 6.47437 4.05327 5.50722 4.78017 4.78033C5.50707 4.05343 6.47422 3.65302 7.50296 3.65302C8.53171 3.65302 9.49886 4.05343 10.2258 4.78033C10.9527 5.50722 11.3531 6.47437 11.3531 7.50312C11.3531 8.53186 10.9527 9.49901 10.2258 10.2259C9.4927 10.9528 8.53171 11.3532 7.50296 11.3532ZM7.50296 4.47232C5.83356 4.47232 4.47216 5.82755 4.47216 7.50312C4.47216 9.17252 5.8274 10.5339 7.50296 10.5339C9.17237 10.5339 10.5338 9.17868 10.5338 7.50312C10.5276 5.83371 9.17237 4.47232 7.50296 4.47232Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1036 3.52645C12.5119 3.52645 12.8428 3.19548 12.8428 2.78721C12.8428 2.37894 12.5119 2.04797 12.1036 2.04797C11.6953 2.04797 11.3643 2.37894 11.3643 2.78721C11.3643 3.19548 11.6953 3.52645 12.1036 3.52645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.e3cee8b9.svg";
export { ForwardRef as ReactComponent };